<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head :searchConfig="tableData.searchConfig" @searchData="searchData" />
    </template>
    <template>
      <Body
        :headConfig="tableData.headConfig"
        :tableData="data.content"
        @editId="editId"
        @editGroup="editGroup"
        @performance="performance"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import getMyPageInfoPage from "@/api/getMyPageInfoPage.js";
import updateFlagId from "@/api/updateFlagId.js";
import updateFlagGroup from "@/api/updateFlagGroup.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
export default {
  mixins: [requstData({ content: [], total: 10 })],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "id",
          list: [
            { label: "专页名称", prop: "pageName", width: "250" },
            { label: "专页ID", prop: "pageId", width: "250" },
            { label: "授权管理员", prop: "authorizationAdmin", width: "250" },
            { label: "授权日期", prop: "authorizationDate", width: "250" },
            { label: "标识ID", prop: "flagId" },
            { label: "标识组别", prop: "flagGroup" },
            {
              label: "操作",
              width: "300",
              operation: [
                {
                  type: 1,
                  label: "编辑标识",
                  style: "primary",
                  listeners: "editId",
                },
                {
                  type: 2,
                  label: "编辑组别",
                  style: "primary",
                  listeners: "editGroup",
                },
                {
                  type: 3,
                  label: "查看成效",
                  style: "danger",
                  listeners: "performance",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "input",
              model: "blendParam",
              span: 4,
              placeholder: "请输入专页ID或标识ID",
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async requst(params) {
      return await getMyPageInfoPage(params);
    },
    message(info) {
      this.$prompt(info.tip, info.title, {
        confirmButtonText: "保存",
        cancelButtonText: "删除",
        cancelButtonClass: "messageCancel",
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            if (!instance.inputValue) {
              this.$message({
                showClose: true,
                message: info.tip,
                type: "error",
              });
              return;
            }
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "保存中...";
            let res = await info.callback(info.id, instance.inputValue);
            if (res === "ok") {
              done();
              this.getData();
            }
            instance.confirmButtonLoading = false;
          } else if (action === "cancel") {
            instance.cancelButtonLoading = true;
            instance.cancelButtonText = "删除中...";
            let res = await info.callback(info.id, null);
            if (res === "ok") {
              done();
              this.getData();
            }
            instance.cancelButtonLoading = false;
          } else {
            done();
          }
        },
      })
        .then(({ value }) => {
          this.$message({
            showClose: true,
            type: "success",
            message: "保存成功",
          });
        })
        .catch((action) => {
          if (action === "cancel") {
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功",
            });
          }
        });
    },
    editId(data) {
      this.message({
        id: data.id,
        title: "编辑标识ID",
        tip: `请输入 ${data.pageName} 的标识ID`,
        callback: async (id, flag) => {
          return await updateFlagId({ id, flagId: flag });
        },
      });
    },
    editGroup(data) {
      this.message({
        id: data.id,
        title: "编辑标识组别",
        tip: `请输入 ${data.pageName} 的标识组别`,
        callback: async (id, flag) => {
          return await updateFlagGroup({ id, flagGroup: flag });
        },
      });
    },
    performance(data) {
      this.$router.push(`performance/${data.pageId}?pageName=${data.pageName}`);
    },
  },
};
</script>

<style lang="less">
.messageCancel {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;

  &:hover {
    background: #f78989;
    border-color: #f78989;
    color: #fff;
  }
}
</style>
